<template>
  <div class="sale__badge">
    <SfBadge class="sale">{{ text }}</SfBadge>
  </div>
</template>
<script>
import { defineComponent, computed } from '@vue/composition-api';
import { SfBadge } from '@storefront-ui/vue';

export default defineComponent({
  name: 'HighlightBadge',
  components: {
    SfBadge,
  },
  props: {
    text: String,
    label: String,
  },
  setup() {},
});
</script>
<style lang="scss">
.sale__badge {
  .sf-badge {
    --badge-background: #222222;
    --badge-font: normal normal medium 12px/60px Work Sans;
    --badge-padding: 0;
    text-align: center;
    letter-spacing: 0;
    padding: 4px 6px;
    @include for-mobile {
      --badge-width: 40px;
      --badge-height: 20px;
      font-size: 9px;
      line-height: 20px;
    }
  }
}
</style>
